import React, { useState, useEffect } from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { Collapse, TextField, Grid, Box } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Switch from 'react-switch';
import ConfigBusiness from '../../commons/config/ConfigBusiness.js';

const FILTER_STATE_INIT = {
  nombre: '',
  showInactivos: false,
  tipoItem: null,
};

const ItemClasificacionesGridFiltros = (props) => {
  const intl = useIntl();
  const [filtersState, setFiltersState] = useState({ ...FILTER_STATE_INIT });

  useEffect(() => {
    if (props.filterResetInputs) {
      setFiltersState({ ...FILTER_STATE_INIT });
      props.setFilterResetInputs && props.setFilterResetInputs(false);
    }
  }, [props.filterResetInputs]);

  useEffect(() => {
    !props.dropdownActive && props.setFilterResetInputs(false);
  }, [props.dropdownActive]);

  const triggerFilter = (state) => {
    const current = state !== undefined ? state : filtersState;
    props.handleFilterChange();
    props.setSearchActive(current.nombre !== '');
    props.setFilterQuery({
      nombre: current.nombre,
      showInactivos: current.showInactivos,
      tipoItem: current.tipoItem ? current.tipoItem.id : '',
    });
  };

  const handleChange = (name, value) => {
    setFiltersState((prev) => ({ ...prev, [name]: value }));
  };

  const handleOnEnter = (e, name) => {
    if (e.keyCode === 13) {
      e.preventDefault();
      handleBuscar({ ...filtersState, [name]: e.target.value });
    }
  };

  const handleSelectChange = (name, value) => {
    setFiltersState((prev) => ({ ...prev, [name]: value }));
  };

  const handleSwitch = (name, value) => {
    const updated = { ...filtersState, [name]: value };
    setFiltersState(updated);
    triggerFilter(updated);
  };

  const handleBuscar = (state) => {
    triggerFilter(state);
  };

  return (
    <Collapse in={props.dropdownActive}>
      <Grid container item xs={12} spacing={2} style={{ marginBottom: 16, marginTop: 4 }}>
        <Grid component={Box} item xs={12} sm={6} md={3} lg={2}>
          <TextField
            label={intl.formatMessage({ id: 'Clasificación', defaultMessage: 'Clasificación' })}
            name="nombre"
            value={filtersState.nombre}
            onChange={(e) => handleChange('nombre', e.target.value)}
            onKeyDown={(e) => handleOnEnter(e, 'nombre')}
            className="col-12"
          />
        </Grid>
        {ConfigBusiness.get('tickets.trabajaConManoDeObra.habilitado') === 'true' && (
          <Grid component={Box} item xs={12} sm={6} md={3} lg={2}>
            <Autocomplete
              size="small"
              name="tipoItem"
              options={[
                { id: 1, label: intl.formatMessage({ id: 'itemClasificacionesAbm.tipoItem.repuesto', defaultMessage: 'Repuesto/Producto' }) },
                { id: 2, label: intl.formatMessage({ id: 'itemClasificacionesAbm.tipoItem.manoDeObra', defaultMessage: 'Mano de Obra' }) },
              ]}
              value={filtersState.tipoItem}
              defaultValue={null}
              getOptionLabel={(option) => option ? option.label : ''}
              onChange={(_, value) => handleSelectChange('tipoItem', value)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="standard"
                  label={intl.formatMessage({ id: 'itemClasificacionesAbm.render.general_data.aplica_a', defaultMessage: 'Aplica a' })}
                  placeholder={intl.formatMessage({ id: 'itemClasificacionesAbm.render.general_data.aplica_a', defaultMessage: 'Aplica a' })}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  }}
                />
              )}
            />
          </Grid>
        )}
        <Grid container item xs={12} spacing={2} alignItems="center">
          <Grid component={Box} item xs="auto" style={{ paddingRight: 20 }}>
            <div className="d-flex align-items-center" style={{ gap: 8 }}>
              <FormattedMessage id="itemClasificacionesAbm.render.filtros.ver_inactivos" defaultMessage="Ver Inactivas" />
              <Switch
                onChange={(value) => handleSwitch('showInactivos', value)}
                checked={filtersState.showInactivos}
                offColor="#FF4961"
                onColor="#28D094"
              />
            </div>
          </Grid>
          <Grid component={Box} item style={{ flex: 1 }} />
          <Grid component={Box} item xs="auto">
            <button
              disabled={props.loading}
              className="btn btn-primary"
              onClick={() => handleBuscar()}
            >
              <i className="fa fa-search fa-xs"></i> <FormattedMessage id="Buscar" defaultMessage="Buscar" />
            </button>
          </Grid>
        </Grid>
      </Grid>
    </Collapse>
  );
};

export default ItemClasificacionesGridFiltros;
